import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../auth.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-logout',
    imports: [],
    templateUrl: './logout.component.html',
    styleUrl: './logout.component.less'
})
export class LogoutComponent implements OnInit, OnDestroy {

  private subscription = new Subscription();

  logoutToken!: string;

  constructor(private authService: AuthService) {
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public ngOnInit(): void {
    this.createLogoutToken();
  }

  createLogoutToken(): void {
    this.subscription.add(
      this.authService.createLogoutFlowToken()
        .subscribe({
          next: (token) => {
            this.logoutToken = token;
          },
          error: (err: any) => {
            console.log(err);
          }
        }));
  }

  onLogout(): void {
    this.subscription.add(
      this.authService.logout(this.logoutToken)
        .subscribe({
          next: () => {
          },
          error: (err: any) => {
            console.log(err);
          }
        })
    );
  }
}
